/** Loads https://checkout.razorpay.com/v1/checkout.js once. */
const POLL_MS = 50;
const MAX_WAIT_MS = 15000;

function waitForRazorpayGlobal(maxMs = MAX_WAIT_MS) {
  return new Promise((resolve, reject) => {
    const t0 = Date.now();
    const tick = () => {
      if (typeof window !== 'undefined' && typeof window.Razorpay === 'function') {
        resolve();
        return;
      }
      if (Date.now() - t0 >= maxMs) {
        reject(new Error('Razorpay script did not become ready in time.'));
        return;
      }
      setTimeout(tick, POLL_MS);
    };
    tick();
  });
}

export function loadRazorpayScript() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('no window'));
  }
  if (typeof window.Razorpay === 'function') {
    return Promise.resolve();
  }

  const existing = document.querySelector('script[data-razorpay-checkout]');
  if (existing) {
    // `load` may have already fired — waiting on it would hang forever.
    return waitForRazorpayGlobal();
  }

  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = 'https://checkout.razorpay.com/v1/checkout.js';
    s.async = true;
    s.setAttribute('data-razorpay-checkout', '1');
    s.onload = () => {
      if (typeof window.Razorpay === 'function') resolve();
      else waitForRazorpayGlobal().then(resolve).catch(reject);
    };
    s.onerror = () => reject(new Error('Could not load Razorpay'));
    document.body.appendChild(s);
  });
}
